import axios from 'axios'

export function addUsersToThread(threadId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/add-users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getThreadSharingSetings() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sharing-settings?filter[for-threads]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function updateThread(threadId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createComments(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/comments', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getThreadComments(threadId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/comments', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getThreadMembers(threadId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/get-users?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteThread(threadId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeThreadMember(threadId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/remove-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function searchActivityUsersThreadExcluded(activityId, threadId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[members-excluded-from-thread]=' + threadId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function leaveThread(threadId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/leave-thread', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteCommentThread(commentId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/comments/' + commentId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function pinCommentThread(commentId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/comments/' + commentId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getThread(threadId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '?withCount=comments&withUsersCount=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function subscribeToThread(threadId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/subscribe', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function unsubscribeToThread(threadId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/unsubscribe', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function uploadFileComment(threadId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeFileComment(threadId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads/' + threadId + '/-actions/remove-file', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}